import type { BookingDetailsState } from '../../domain/types'
import { isActiveUpcomingBooking, isOnHolidays } from '@/scopes/account/common/utils/bookingDates'

export type AppPromotionPlacement = 'on-holidays' | 'upcoming' | null

export function getAppPromotionPlacement(
  state: BookingDetailsState,
  currentDate: Date = new Date(),
): AppPromotionPlacement {
  if (state.isCancelled) {
    return null
  }

  if (isOnHolidays(state.rawDepartureDate, state.rawReturnDate, currentDate)) {
    return 'on-holidays'
  }

  if (isActiveUpcomingBooking(state.rawDepartureDate, state.isCancelled, currentDate)) {
    return 'upcoming'
  }

  return null
}
